import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingService } from './../../../../core/services/api/setting.service';
import { Item } from './../../../../core/models/share/item';
import { PaymentMethod } from '../../../../core/models/payment/payment-method';
import { AccountService } from '../../../../core/services/api/account.service';
import { ErrorService } from '../../../../core/services/error.service';
import { BlockUiService } from '../../../../shared/services/blockUi/block-ui.service';
import { finalize } from 'rxjs/operators';
import { PopupService } from '../../../../shared/services/popup/popup.service';
@Component({
    selector: 'app-my-investments-refund',
    templateUrl: './my-investments-refund.component.html',
    styleUrls: ['./my-investments-refund.component.css'],
    standalone: false
})

export class MyInvestmentsRefundComponent {
    bankId: number | null = null;
    bankName = '';
    accountHolder = '';
    accountNumber = '';
    bankList: Item[];
    isLoading = true;
    paymentMethod: PaymentMethod;

    constructor(
        public activeModal: NgbActiveModal,
        private settingService: SettingService,
        private readonly accountService: AccountService,
        private readonly errorService: ErrorService,
        private readonly blockUiService: BlockUiService,
        private readonly popupService: PopupService,
    ) { }

    ngOnInit() {
        this.getBankList();
    }

    getBankList() {
        this.settingService.getBankList().subscribe(
            (data) => {
                this.bankList = data.filter(b => b.id != 0);
                this.getProfilePaymentMethods();
            },
            (err) => this.errorService.showError(err)
        );
    }

    getProfilePaymentMethods(): void {
        this.isLoading = true;

        this.accountService
            .getProfilePaymentMethods()
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (data: any) => {
                    this.paymentMethod = data || {};

                    // Prefill if exists
                    if (this.paymentMethod?.accountHolder && this.paymentMethod?.accountNumber) {
                        this.bankId = this.paymentMethod.bankId || null;
                        this.accountHolder = this.paymentMethod.accountHolder || '';
                        this.accountNumber = this.paymentMethod.accountNumber || '';
                    }
                },
                error: (err) => {
                    this.errorService.showError(err);
                },
            });
    }

    saveRefundDetails() {
        const accountNumberPattern = /^\d+$/;
        if (!this.bankId || !this.accountHolder?.trim() || !this.accountNumber?.trim() || !accountNumberPattern.test(this.accountNumber.trim())|| this.accountNumber.trim().length > 34){
            this.popupService.alert('common.missingFieldsAlert');
            return;
        }

        const updatedPaymentMethod: PaymentMethod = {
            bankId: Number(this.bankId),
            bankName: this.bankList.find(b => b.id === this.bankId)?.name || '',
            accountHolder: this.accountHolder.trim(),
            accountNumber: this.accountNumber.trim(),
            amount: this.paymentMethod?.amount || 0
        };


        this.blockUiService.open();
        this.accountService
            .updateProfilePaymentMethods(updatedPaymentMethod)
            .pipe(finalize(() => this.blockUiService.close()))
            .subscribe({
                next: () => {
                    this.activeModal.close({
                        bankId: updatedPaymentMethod.bankId,
                        accountHolderName: updatedPaymentMethod.accountHolder,
                        accountNumber: updatedPaymentMethod.accountNumber
                    });
                },
                error: (err) => {
                    this.errorService.showError(err);
                }
            });
    }

    closeModal() {
        this.activeModal.dismiss();
    }
}
